// Sincronización del estado del concurso hacia el overlay de OBS.
// Construye un payload compacto y lo empuja al servidor (throttled) para que
// el overlay (que corre en otro navegador dentro de OBS) lo lea por token.
import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';
import { derivarAutorPregunta } from './autorPregunta';

// Construye el estado que consume el overlay a partir del estado del quiz.
export const construirEstadoOverlay = ({
  preguntas,
  preguntaActual,
  respuestas,
  respuestasMezcladas,
  respuestasMezcladasPreguntaActual,
  respuestasVisibles,
  respuestasEliminadas,
  respuestaSeleccionada,
  respuestaRevelada,
  indiceRespuestaCorrecta,
  puntuacion,
  juegoTerminado,
  comodines,
  tiempoRestante,
  duracionConcurso,
  tiempoLlamada,
  temporizadorLlamadaActivo,
  mostrarTemporizadorLlamada,
  mostrarGraficoPublico,
  datosGraficoPublico,
  tiempoRestantePublico,
  temporizadorPublicoActivo,
  votosPublico,
  sobornoVisible,
}) => {
  const pregunta = preguntas[preguntaActual] || null;

  // Estado por pregunta para la barra de progreso: pendiente | acierto | fallo
  const progreso = preguntas.map((_, index) => {
    const respuesta = respuestas[index];
    if (respuesta === null || respuesta === undefined) {
      return 'pendiente';
    }
    const mezcla = respuestasMezcladas[index];
    const indiceCorrecta = mezcla ? mezcla.findIndex((r) => r.esCorrecta) : -1;
    return respuesta === indiceCorrecta ? 'acierto' : 'fallo';
  });

  const respuestasActuales = (respuestasMezcladasPreguntaActual || []).map((r) => ({
    texto: r.texto,
    esCorrecta: !!r.esCorrecta,
  }));

  // Autor a mostrar en el overlay (foto a la derecha de la pregunta).
  // Solo se envía la foto de autores "usuario" reales; Anónimo, Sistema,
  // ChatGPT, moderadores y administradores quedan excluidos.
  const autor = derivarAutorPregunta(pregunta);

  return {
    version: 1,
    activo: preguntas.length > 0 && !juegoTerminado,
    juegoTerminado: !!juegoTerminado,
    preguntaActual,
    totalPreguntas: preguntas.length,
    puntuacion,
    pregunta: pregunta ? pregunta.pregunta : null,
    autorFoto: autor.mostrarFoto ? autor.fotoAutor : '',
    autorNombre: autor.esAutorUsuario ? autor.nombreAutor : '',
    explicacion: pregunta ? (pregunta.explicacion || '') : '',
    explicacionImagen: pregunta ? (pregunta.imagen_url || '') : '',
    respuestas: respuestasActuales,
    respuestasVisibles,
    respuestasEliminadas: (respuestasEliminadas && respuestasEliminadas[preguntaActual]) || [],
    respuestaSeleccionada,
    respuestaRevelada: !!respuestaRevelada,
    indiceRespuestaCorrecta,
    progreso,
    comodines,
    duracionConcurso,
    tiempoRestante,
    llamada: {
      visible: !!mostrarTemporizadorLlamada,
      tiempo: tiempoLlamada,
      activo: !!temporizadorLlamadaActivo,
    },
    publico: {
      visible: !!mostrarGraficoPublico,
      activo: !!temporizadorPublicoActivo,
      tiempo: tiempoRestantePublico,
      datos: datosGraficoPublico,
      votos: votosPublico,
    },
    soborno: {
      visible: !!sobornoVisible,
    },
  };
};

// Envío throttled: colapsa ráfagas y garantiza que el último estado se envíe.
const INTERVALO_MIN_MS = 250;
let ultimoEnvio = 0;
let pendiente = null;
let temporizador = null;

const flush = () => {
  temporizador = null;
  ultimoEnvio = Date.now();
  const payload = pendiente;
  pendiente = null;
  if (!payload) return;
  axios
    .post(`${API_BASE_URL}/overlay_estado.php`, payload, { withCredentials: true })
    .catch(() => {
      // El overlay es best-effort; no interrumpir el concurso por un fallo de red.
    });
};

export const enviarEstadoOverlay = (estado) => {
  pendiente = estado;
  const ahora = Date.now();
  const transcurrido = ahora - ultimoEnvio;

  if (transcurrido >= INTERVALO_MIN_MS) {
    flush();
  } else if (!temporizador) {
    temporizador = setTimeout(flush, INTERVALO_MIN_MS - transcurrido);
  }
};
